export enum PBtnAiType {
  PRIMARY = 'primary',
  TERTIARY = 'tertiary',
}
